// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/markets/post_resolution.proto (package morfi.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EventMetadata } from "../common_pb.js";
import { file_morfi_v1_common } from "../common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/markets/post_resolution.proto.
 */
export const file_morfi_v1_markets_post_resolution: GenFile = /*@__PURE__*/
  fileDesc("CiZtb3JmaS92MS9tYXJrZXRzL3Bvc3RfcmVzb2x1dGlvbi5wcm90bxIIbW9yZmkudjEixQEKEVByaXplQ2xhaW1lZEV2ZW50EiUKBG1ldGEYASABKAsyFy5tb3JmaS52MS5FdmVudE1ldGFkYXRhEg4KBm1hcmtldBgCIAEoDBIPCgdjbGFpbWVyGAMgASgMEhMKC2J1cm5fYW1vdW50GAQgASgEEhQKDHF1b3RlX3BheW91dBgFIAEoBBIbChN2YXVsdF9iYWxhbmNlX2FmdGVyGAYgASgEEhQKDHN1cHBseV9hZnRlchgHIAEoBBIKCgJ0cxgIIAEoAyJwChBNYXJrZXRQcml6ZUNsYWltEhMKC3NlcXVlbmNlX2lkGAEgASgMEgoKAnRzGAIgASgEEhEKCWFtb3VudF9kNhgDIAEoBBIYCgtvdXRjb21lX2lkeBgEIAEoDUgAiAEBQg4KDF9vdXRjb21lX2lkeCLJAQoVQmFja2VyRmVlQ2xhaW1lZEV2ZW50EiUKBG1ldGEYASABKAsyFy5tb3JmaS52MS5FdmVudE1ldGFkYXRhEg4KBm1hcmtldBgCIAEoDBIPCgdjbGFpbWVyGAMgASgMEhMKC2J1cm5fYW1vdW50GAQgASgEEhQKDHF1b3RlX3BheW91dBgFIAEoBBIbChN2YXVsdF9iYWxhbmNlX2FmdGVyGAYgASgEEhQKDHN1cHBseV9hZnRlchgHIAEoBBIKCgJ0cxgIIAEoAyL8AQoPR3JhZHVhdGlvbkV2ZW50EiUKBG1ldGEYASABKAsyFy5tb3JmaS52MS5FdmVudE1ldGFkYXRhEg4KBm1hcmtldBgCIAEoDBIXCg93aW5uaW5nX291dGNvbWUYAyABKA0SFwoPd2lubmluZ19iY19taW50GAQgASgMEhAKCGFtbV9wb29sGAUgASgMEhsKE3F1b3RlX3NlZWRlZF90b19hbW0YBiABKAQSFwoPYW1tX3NlZWRfdG9rZW5zGAcgASgEEgoKAnRzGAggASgDEiwKJHdpbm5pbmdfb3V0Y29tZV9taW50X3N1cHBseV9hZnRlcl9kNhgJIAEoBGIGcHJvdG8z", [file_morfi_v1_common]);

/**
 * @generated from message morfi.v1.PrizeClaimedEvent
 */
export type PrizeClaimedEvent = Message<"morfi.v1.PrizeClaimedEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes market = 2;
   */
  market: Uint8Array;

  /**
   * @generated from field: bytes claimer = 3;
   */
  claimer: Uint8Array;

  /**
   * @generated from field: uint64 burn_amount = 4;
   */
  burnAmount: bigint;

  /**
   * @generated from field: uint64 quote_payout = 5;
   */
  quotePayout: bigint;

  /**
   * @generated from field: uint64 vault_balance_after = 6;
   */
  vaultBalanceAfter: bigint;

  /**
   * @generated from field: uint64 supply_after = 7;
   */
  supplyAfter: bigint;

  /**
   * @generated from field: int64 ts = 8;
   */
  ts: bigint;
};

/**
 * Describes the message morfi.v1.PrizeClaimedEvent.
 * Use `create(PrizeClaimedEventSchema)` to create a new message.
 */
export const PrizeClaimedEventSchema: GenMessage<PrizeClaimedEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_post_resolution, 0);

/**
 * Typed realtime payload for `morfi.market.{market}.user.{user}.claim.v0`.
 * The market is carried by the subject; outcome_idx is the on-chain
 * PrizeClaimedEvent.winning_outcome.
 *
 * @generated from message morfi.v1.MarketPrizeClaim
 */
export type MarketPrizeClaim = Message<"morfi.v1.MarketPrizeClaim"> & {
  /**
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: uint64 amount_d6 = 3;
   */
  amountD6: bigint;

  /**
   * @generated from field: optional uint32 outcome_idx = 4;
   */
  outcomeIdx?: number | undefined;
};

/**
 * Describes the message morfi.v1.MarketPrizeClaim.
 * Use `create(MarketPrizeClaimSchema)` to create a new message.
 */
export const MarketPrizeClaimSchema: GenMessage<MarketPrizeClaim> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_post_resolution, 1);

/**
 * @generated from message morfi.v1.BackerFeeClaimedEvent
 */
export type BackerFeeClaimedEvent = Message<"morfi.v1.BackerFeeClaimedEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes market = 2;
   */
  market: Uint8Array;

  /**
   * @generated from field: bytes claimer = 3;
   */
  claimer: Uint8Array;

  /**
   * @generated from field: uint64 burn_amount = 4;
   */
  burnAmount: bigint;

  /**
   * @generated from field: uint64 quote_payout = 5;
   */
  quotePayout: bigint;

  /**
   * @generated from field: uint64 vault_balance_after = 6;
   */
  vaultBalanceAfter: bigint;

  /**
   * @generated from field: uint64 supply_after = 7;
   */
  supplyAfter: bigint;

  /**
   * @generated from field: int64 ts = 8;
   */
  ts: bigint;
};

/**
 * Describes the message morfi.v1.BackerFeeClaimedEvent.
 * Use `create(BackerFeeClaimedEventSchema)` to create a new message.
 */
export const BackerFeeClaimedEventSchema: GenMessage<BackerFeeClaimedEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_post_resolution, 2);

/**
 * @generated from message morfi.v1.GraduationEvent
 */
export type GraduationEvent = Message<"morfi.v1.GraduationEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes market = 2;
   */
  market: Uint8Array;

  /**
   * @generated from field: uint32 winning_outcome = 3;
   */
  winningOutcome: number;

  /**
   * @generated from field: bytes winning_bc_mint = 4;
   */
  winningBcMint: Uint8Array;

  /**
   * @generated from field: bytes amm_pool = 5;
   */
  ammPool: Uint8Array;

  /**
   * @generated from field: uint64 quote_seeded_to_amm = 6;
   */
  quoteSeededToAmm: bigint;

  /**
   * @generated from field: uint64 amm_seed_tokens = 7;
   */
  ammSeedTokens: bigint;

  /**
   * @generated from field: int64 ts = 8;
   */
  ts: bigint;

  /**
   * @generated from field: uint64 winning_outcome_mint_supply_after_d6 = 9;
   */
  winningOutcomeMintSupplyAfterD6: bigint;
};

/**
 * Describes the message morfi.v1.GraduationEvent.
 * Use `create(GraduationEventSchema)` to create a new message.
 */
export const GraduationEventSchema: GenMessage<GraduationEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_post_resolution, 3);

